import { OrganizationUserRole } from '@shared/types';

export const ORGANIZATION_USER_ROLES: {
  [key in OrganizationUserRole]: OrganizationUserRole;
} = {
  [OrganizationUserRole.ADMIN]: OrganizationUserRole.ADMIN,
  [OrganizationUserRole.MEMBER]: OrganizationUserRole.MEMBER,
  [OrganizationUserRole.VIEW_ONLY_MEMBER]:
    OrganizationUserRole.VIEW_ONLY_MEMBER,
  [OrganizationUserRole.LLM_ONLY]: OrganizationUserRole.LLM_ONLY
};

export const ORGANIZATIONS_SETTINGS = {
  WORKSPACE_CREATOR_BECOMES_OWNER: 'workspace-creator-becomes-owner',
  ONLY_ADMIN_INVITE_FROM_OUTSIDE_ORGANIZATION:
    'only-admin-invite-from-outside-organization',
  MODEL_ITEM_SUPPORTED_STATUSES: 'model-item-supported-statuses',
  CONNECTED_TO_SLACK: 'connected-to-slack',
  FULL_METRICS_ENABLED: 'full-metrics-enabled',
  WEBHOOK_SECRET_KEYS: 'webhook-secret-keys'
};

export const SLACK_STATUS = {
  CONNECTED: 'CONNECTED',
  NOT_CONNECTED_CLOUD: 'NOT_CONNECTED_CLOUD',
  NOT_CONNECTED_ONPREM: 'NOT_CONNECTED_ONPREM'
} as const;
